import { createTheme, responsiveFontSizes } from '@mui/material';

import {
  alertTypes,
  buttonTypes,
  cardTypes,
  dialogTypes,
  inputTypes,
  menuTypes,
  muiPalette,
  stackTypes,
  tableTypes,
  tabsTypes,
  toolbarTypes,
  typographyTypes,
} from './components';

const theme = createTheme({
  palette: muiPalette,
  shape: {
    borderRadius: '0.75rem',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Poppins, Arial, sans-serif',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: muiPalette.divider,
        },
      },
    },
    MuiTypography: {
      styleOverrides: typographyTypes.TypographyStyles,
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: buttonTypes.ButtonStyles(muiPalette),
    },
    MuiAlert: {
      styleOverrides: alertTypes.AlertStyles,
    },
    MuiStack: {
      styleOverrides: stackTypes.StackStyles,
    },
    MuiTab: {
      styleOverrides: tabsTypes.TabsStyles,
    },
    MuiMenu: {
      styleOverrides: menuTypes.MenuStyles,
    },
    MuiMenuItem: {
      styleOverrides: menuTypes.MenuItemStyles,
      variants: menuTypes.MenuItemVariants,
    },
    MuiMenuList: {
      styleOverrides: menuTypes.MenuMenuListStyles,
    },
    MuiListItemIcon: {
      styleOverrides: menuTypes.ListItemIconStyles,
    },
    MuiInputBase: {
      styleOverrides: inputTypes.InputBaseStyles,
    },
    MuiOutlinedInput: {
      styleOverrides: inputTypes.OutlinedInputStyles(muiPalette),
    },
    MuiToolbar: {
      styleOverrides: toolbarTypes.ToolbarStyles,
    },
    MuiTable: {
      styleOverrides: tableTypes.TableStyles(muiPalette),
    },
    MuiTableRow: {
      styleOverrides: tableTypes.RowStyles(muiPalette),
    },
    MuiTableCell: {
      styleOverrides: tableTypes.CellStyles(muiPalette),
    },
    MuiTablePagination: {
      styleOverrides: tableTypes.PaginationStyles(muiPalette),
    },
    MuiDialog: {
      styleOverrides: dialogTypes.DialogStyles,
    },
    MuiDialogContent: {
      styleOverrides: dialogTypes.DialogContentStyles,
    },
    MuiDialogActions: {
      styleOverrides: dialogTypes.DialogActionsStyles,
    },
    MuiCard: {
      styleOverrides: cardTypes.CardStyles(muiPalette),
    },
  },
});

export const generalTheme = responsiveFontSizes(theme);